module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vernalEquinox":"Vernal equinox","summerSolstice":"Summer solstice","autumnalEquinox":"Autumnal equinox","winterSolstice":"Winter solstice"},"ru":{"vernalEquinox":"Весеннее равноденствие","summerSolstice":"Летнее солнцестояние","autumnalEquinox":"Осеннее равноденствие","winterSolstice":"Зимнее солнцестояние"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ecliptic.vue
// module id = 695
// module chunks = 0